// @flow
import { useMemo } from 'react';
import moment from 'moment-timezone';

import config from 'app/config';

import * as dateTypes from 'app/common/constants/dateTypes';


/**
 * Hook для создания from-to дат,
 * на основе даты и типа даты (месяц или день)
 * (если день, то to === from)
 */

type Props = {
  date: string,
  dateType: $Values<typeof dateTypes>,
}

const useFromTo = ({ date, dateType }: Props) => useMemo(() => {
  const mDate = moment(date, config.dateFormat);
  if (!mDate.isValid()) {
    const today = moment().format(config.dateFormat);
    return [today, today];
  }
  if (dateType === dateTypes.DAYS) {
    return [date, date];
  }
  const startDate = mDate.startOf('month').format(config.dateFormat);
  const finalDate = mDate.endOf('month').format(config.dateFormat);
  return [startDate, finalDate];
}, [date, dateType]);

export default useFromTo;
